'use client';

import MainPageLanguageSelector from './MainPageLanguageSelector';
import Link from 'next/link';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PiTelegramLogoLight } from 'react-icons/pi';
import { useLanguageFromPath } from '@/hooks/useLanguageFromPath';

const MainFooter = () => {
  const { t, i18n } = useTranslation();
  const displayLang = useLanguageFromPath();

  // Sync i18next language with the detected language
  useEffect(() => {
    if (i18n?.language !== displayLang) {
      i18n.changeLanguage(displayLang).catch(() => {
        /* optional: handle load errors */
      });
    }
  }, [displayLang, i18n]);

  // Get translations (async updates in background)
  const labels = {
    articles: t('footer.articles'),
    startLearning: t('homePage.startLearning'),
    contactUs: t('footer.contactUs'),
    telegram: t('footer.telegram'),
    copyright: t('footer.copyright'),
  };

  return (
    <footer className='w-full bg-white border-t pt-10 mt-8 flex flex-col items-center justify-between'>
      <div className='w-full flex flex-row justify-between items-start mb-16'>
        <div className='flex flex-col justify-between gap-4'>
          <div className='font-semibold text-3xl'>
            <Link href='/' className='text-3xl font-extralight'>
              DarPiano
            </Link>
          </div>
        </div>
        <div className='grid grid-cols-1 sm:grid-cols-3 gap-x-16 gap-y-2'>
          <div className='flex flex-col gap-2 font-normal text-md'>
            <Link href='/posts'>
              {labels.articles}
            </Link>
          </div>
          <div className='flex flex-col gap-2'>
            <Link href='/'>
              {labels.startLearning}
            </Link>
            <Link
              href='https://t.me/darpianocom'
              target='_blank'
              rel='noopener noreferrer'
            >
              {labels.contactUs}
            </Link>
          </div>
          <div className='mb-4 flex flex-col order-first sm:order-last'>
            {/* Language Selector */}
            <MainPageLanguageSelector />
          </div>
        </div>
      </div>
      <div className='w-full flex flex-wrap gap-2 justify-between text-sm text-gray-500'>
        <Link
          href='https://t.me/darpianocom'
          className='flex items-center gap-1'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Telegram'
        >
          <div className='pr-0.5'>
            <PiTelegramLogoLight size={20} />
          </div>
          {labels.telegram}
        </Link>
        <span>{labels.copyright}</span>
      </div>
    </footer>
  );
};

export default MainFooter;
